import palette from 'theme/palette'

export default {
  root: {
    '&$focused': {
      color: palette.secondary.dark,
    },
  },
}
